import { getCotizacion } from './getCotizacion'
import { getCotizacionForPresupuestador } from './getCotizacionForPresupuestador'
import { getCotizacionForGO } from './getCotizacionForGO'
import { getHistoryPrice } from './getHistoryPrice'
import { generateExcel } from './generateExcel'
import { getQuotations } from './getQuotations'
import { generatePDF } from './generatePDF'
import { getQuotationById } from './getQuotationById'

export const Cotizador = {
  getCotizacion,
  getCotizacionForPresupuestador,
  getCotizacionForGO,
  getHistoryPrice,
  generateExcel,
  getQuotations,
  generatePDF,
  getQuotationById,
}
